import Vue from 'vue';
import Vuex from 'vuex';
import agent from 'widget/store/modules/agent';
import aiAgent from 'widget/store/modules/aiAgent';
import appConfig from 'widget/store/modules/appConfig';
import contacts from 'widget/store/modules/contacts';
import conversation from 'widget/store/modules/conversation';
import conversationAttributes from 'widget/store/modules/conversationAttributes';
import conversationLabels from 'widget/store/modules/conversationLabels';
import events from 'widget/store/modules/events';
import globalConfig from 'shared/store/globalConfig';
import message from 'widget/store/modules/message';
import campaign from 'widget/store/modules/campaign';
import article from 'widget/store/modules/articles';
import flipperFeatures from 'widget/store/modules/flipperFeatures';
import inboxChatResources from 'widget/store/modules/inboxChatResources';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    agent,
    aiAgent,
    appConfig,
    contacts,
    conversation,
    conversationAttributes,
    conversationLabels,
    events,
    flipperFeatures,
    globalConfig,
    message,
    campaign,
    article,
    inboxChatResources,
  },
});
